"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocalStorage = exports.setDefaultMobile = exports.scrollUnlock = exports.scrollLocked = exports.scrollLock = exports.saveUTMSessionParams = exports.sanitizeUrl = exports.isMobile = exports.getWidthParameter = exports.getUTMSessionParams = exports.getUTMParametersFromSessionCache = exports.getUTMParameters = exports.getSafeUrl = exports.getQueryString = exports.getQueryParams = exports.getLocalStorage = exports.getHashString = exports.getHashParams = exports.getComponentItemValue = exports.getClickIds = exports.exportUTMParametersFromSessionCache = exports.debounceEvent = exports.componentItemsEqual = exports.clearUTMSessionParams = exports.buildQueryString = void 0;
var utmKeywords = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'gclid', 'msclkid', 'fbclid', 'utm_adgroup', 'utm_messaging'];
var debounceEvent = exports.debounceEvent = function debounceEvent(eventHandler, debounceTime) {
  var debounceTimer = 0;
  return function () {
    var localArgs = arguments;
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(function () {
      return eventHandler.apply(null, localArgs);
    }, debounceTime);
  };
};
var scrollLocked = exports.scrollLocked = function scrollLocked() {
  if (typeof document !== 'undefined') {
    return document.body.style.overflow === 'hidden';
  }
};
var scrollLock = exports.scrollLock = function scrollLock() {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = 'hidden';
  }
};
var scrollUnlock = exports.scrollUnlock = function scrollUnlock() {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = 'auto';
  }
};
var defaultMobile = 1051;
var setDefaultMobile = exports.setDefaultMobile = function setDefaultMobile(size) {
  defaultMobile = size;
};
var isMobile = exports.isMobile = function isMobile(size) {
  if (typeof window !== 'undefined') {
    return window.innerWidth < (size || defaultMobile);
  }
};
var getQueryParams = exports.getQueryParams = function getQueryParams() {
  var paramObject = {};
  var queryString = getQueryString();
  var queryStringSplit = queryString.split('&');
  queryStringSplit.forEach(function (keyValue) {
    var firstEqualSignIndex = keyValue.indexOf('=');
    if (firstEqualSignIndex > -1) {
      var keyValueSplit = [keyValue.substring(0, firstEqualSignIndex), keyValue.substring(firstEqualSignIndex + 1)];
      var key = keyValueSplit[0];
      var value = keyValueSplit[1].replace('{amp}', '&');
      paramObject[key] = value;
    }
  });
  return paramObject;
};
var getQueryString = exports.getQueryString = function getQueryString() {
  var hrefSplit = getSafeUrl().split('?');
  if (hrefSplit.length > 1) {
    return decodeURIComponent(hrefSplit[1]);
  }
  return '';
};
var getSafeUrl = exports.getSafeUrl = function getSafeUrl() {
  return typeof window !== 'undefined' ? window.location.href : '';
};
var buildQueryString = exports.buildQueryString = function buildQueryString(queryParamObject) {
  var queryString = [];
  for (var property in queryParamObject) {
    // eslint-disable-next-line no-prototype-builtins
    if (queryParamObject.hasOwnProperty(property)) {
      var value = (queryParamObject[property] || '').toString().replace('&', '{amp}');
      if (value !== null) {
        queryString.push("".concat(encodeURIComponent(property), "=").concat(encodeURIComponent(value)));
      }
    }
  }
  return '?' + queryString.join('&');
};
var localStorage = {};
var getLocalStorage = exports.getLocalStorage = function getLocalStorage(key) {
  if (typeof window === 'undefined') {
    return localStorage[key];
  }
  try {
    return JSON.parse(window.localStorage[key]);
  } catch (_unused) {
    return window.localStorage[key];
  }
};
var setLocalStorage = exports.setLocalStorage = function setLocalStorage(key, value) {
  if (typeof window === 'undefined') {
    localStorage[key] = value;
  }
  if (typeof value !== 'string') {
    window.localStorage[key] = JSON.stringify(value);
  } else {
    window.localStorage[key] = value;
  }
};
var sanitizeUrl = exports.sanitizeUrl = function sanitizeUrl(url) {
  var cleanedSlashes = url.replace(new RegExp('//', 'g'), '/').replace(':/', '://');
  return cleanedSlashes.replace(new RegExp('\\?'), '?');
};

/*
Parameters from the URL.  See also: getUTMParametersFromSessionCache
Consider for deprecation.
*/
var getClickIds = exports.getClickIds = function getClickIds() {
  var params = getQueryParams();
  return {
    GoogleClickId: params['gclid'] || '',
    BingClickId: params['msclkid'] || '',
    FacebookClickId: params['fbclid'] || ''
  };
};
var getHashParams = exports.getHashParams = function getHashParams() {
  var paramObject = {};
  var queryString = getHashString();
  var queryStringSplit = queryString.split('&');
  queryStringSplit.forEach(function (keyValue) {
    var firstEqualSignIndex = keyValue.indexOf('=');
    if (firstEqualSignIndex > -1) {
      var keyValueSplit = [keyValue.substring(0, firstEqualSignIndex), keyValue.substring(firstEqualSignIndex + 1)];
      var key = keyValueSplit[0];
      var value = keyValueSplit[1];
      paramObject[key] = value;
    }
  });
  return paramObject;
};
var getHashString = exports.getHashString = function getHashString() {
  var hrefSplit = getSafeUrl().split('#');
  if (hrefSplit.length > 1) {
    return decodeURIComponent(hrefSplit[1]);
  }
  return '';
};

// consider for deprecation
var getWidthParameter = exports.getWidthParameter = function getWidthParameter(imageReference) {
  var widthParameter;
  if (imageReference.indexOf('ctfassets') > -1) {
    widthParameter = '?w=860';
  } else {
    widthParameter = '?width=860';
  }
  return widthParameter;
};
var componentItemsEqual = exports.componentItemsEqual = function componentItemsEqual(item1, item2) {
  if (item1 === undefined || item1 === null || item2 === undefined || item2 === null) {
    return false;
  }
  return (item1.value !== undefined ? item1.value : item1).toString() === (item2.value !== undefined ? item2.value : item2).toString();
};
var getComponentItemValue = exports.getComponentItemValue = function getComponentItemValue(item) {
  if (item === undefined || item === null) {
    return null;
  }
  return item.value !== undefined ? item.value : item;
};

/*
The calling function must include react-router-dom, and reference the useLocation hook.
For example: const pageRouterLocation = useLocation().search;

Checks the URL for any utm parameters, and saves their values to the session storage.
For example: ?utm_source=facebook&utm_medium=model-feature&utm_id=social

Links from other websites, like Facebook, will include utm parameters in the URL.
This information will be saved to local session storage when available.
As the user navigates our website, the information is no longer available in the URL.
Forms may include this data later, by checking the session storage, and including the data.
*/
var saveUTMSessionParams = exports.saveUTMSessionParams = function saveUTMSessionParams(pageRouterLocation) {
  try {
    //If there's a utm_source, save information to the session storage.
    //Otherwise do nothing.  Leave any existing values.
    var searchParams = new URLSearchParams(pageRouterLocation);
    if (searchParams.get('utm_source')) {
      clearUTMSessionParams();
      utmKeywords.forEach(function (key) {
        var keyValue = searchParams.get(key);
        if (keyValue) {
          window.sessionStorage.setItem(key, keyValue);
        }
      });
    }
  } catch (e) {
    console.error(e);
  }
};

/*
Returns an array of UTM key-value pairs, as saved in the session storage.
This doesn't check for URL parameters. To check for both, see: getUTMParametersFromSessionCache
*/
var getUTMSessionParams = exports.getUTMSessionParams = function getUTMSessionParams() {
  try {
    return utmKeywords.map(function (key) {
      return {
        key: key,
        value: window.sessionStorage.getItem(key) || ''
      };
    });
  } catch (e) {
    console.error(e);
  }
};

/*
Removes all utmKeywords from the session storage.
*/
var clearUTMSessionParams = exports.clearUTMSessionParams = function clearUTMSessionParams() {
  try {
    return utmKeywords.map(function (key) {
      window.sessionStorage.removeItem(key);
    });
  } catch (e) {
    console.error(e);
  }
};
function getUTMSummary(params) {
  var utmSummary = {};
  utmKeywords.forEach(function (key) {
    utmSummary[key] = params[key] || '';
  });
  return utmSummary;
}

//Parameters from the URL. (Existing function.)
var getUTMParameters = exports.getUTMParameters = function getUTMParameters() {
  var params = getQueryParams();
  return getUTMSummary(params);
};

//Parameters from the URL if available, or use the local session cache.
var getUTMParametersFromSessionCache = exports.getUTMParametersFromSessionCache = function getUTMParametersFromSessionCache() {
  var defaultParams = getUTMParameters();
  if (defaultParams['utm_source'] !== '') {
    return defaultParams;
  }
  try {
    var params = {};
    utmKeywords.forEach(function (key) {
      params[key] = window.sessionStorage.getItem(key) || '';
    });
    return getUTMSummary(params);
  } catch (e) {
    console.error(e);
    return {};
  }
};

/*
Fetch any utm parameters, formatted as a url query string.
This is useful when linking to other websites.
*/
var exportUTMParametersFromSessionCache = exports.exportUTMParametersFromSessionCache = function exportUTMParametersFromSessionCache(omitFirstDelimiter) {
  var urlString = '';
  var cache = getUTMParametersFromSessionCache();
  utmKeywords.forEach(function (key) {
    if (cache[key]) {
      urlString += urlString === '' && omitFirstDelimiter === true ? "".concat(key, "=").concat(cache[key]) : "&".concat(key, "=").concat(cache[key]);
    }
  });
  return urlString;
};